export default __webpack_public_path__ + "assets/691362.svg";